import "./Transfer.scss";
import {useEffect, useState} from "react";
import {useTransfersStore} from "../../../../../modules/profile/transfers/store";
import Toaster from "../../../../shared/Toaster";
import {useUserStore} from "../../../../../modules/shop/user/store";
import TransferBlock from "./components/TrasferBlock/TransferBlock";
import TransfersList from "./components/TransfersList/TransfersList";
import {ToasterProps} from "../../../../shared/Toaster/Toaster";

// Переказ балансу: форма зверху, нижче історія переказів
const Transfer = () => {
    const createTransfer = useTransfersStore(state => state.createTransfer)
    const fetchTransfers = useTransfersStore(state => state.fetchTransfers)
    const fetchUser = useUserStore(state => state.fetchUser)
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);

    useEffect(() => {
        fetchTransfers(1)
    }, [])

    return (
        <div className="bc-page">
            <TransferBlock
                createTransfer={createTransfer}
                fetchUser={fetchUser}
                setDataForToaster={setToastProps}
                fetchTransfers={fetchTransfers}
            />
            <TransfersList />
            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </div>
    );
};

export default Transfer;
